// extracted by mini-css-extract-plugin
export var cardLayout = "_5q-1";
export var paginationContainer = "_5q-0";